// extracted by mini-css-extract-plugin
export default {"navBlock":"Nav_navBlock__rtCcQ","active":"Nav_active__jg--2","navParts":"Nav_navParts__oIqJv","homeImg":"Nav_homeImg__rzPlA","ref":"Nav_ref__0xh24"};